import { IIssueSearchResult } from "@mctypes/issue.types";
import { IRegister } from "@mctypes/register.types";
import { IAllFilter } from "@schemas/commonSchema";
import Axios from "axios";

export const doGetIssueBoardsDepricated = async (projectId: string): Promise<IRegister.BoardPopulated[]> => {
  try {
    const logFetch = await Axios.get(`/api/project/${projectId}/issueboard`);
    return logFetch.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};

// TODO: integrate with RTK instead
export const doSearchIssueBoardsDepricated = async (
  projectId: string,
  query: string,
  allFilters: IAllFilter[],
): Promise<IIssueSearchResult[]> => {
  try {
    const result = await Axios.post(`/api/project/${projectId}/issueboard/search`, { query, allFilters });
    return result.data;
  } catch (error) {
    return Promise.reject({ type: "backend", message: error.response?.data });
  }
};
